<template>
  <vue100vh style="position: fixed;width: 100%;">
  <div>
    <!-- <v-dialog v-model="dialogGroup" persistent max-width="550px" max-height= "600px"> -->
      <!-- <v-card> -->
        <v-toolbar style="background-color: white !important;">
          <v-btn icon @click="toPage()">
            <v-icon>chevron_left</v-icon>
          </v-btn>
          <v-toolbar-title>{{$t('LeftSide.createGroup.header')}}</v-toolbar-title>
        </v-toolbar>
        <v-stepper v-model="step_creategroup">
          <v-stepper-items>
            <v-stepper-content step="1">
              <h4 style="padding-left: 10px;">{{$t('Dialog.group.chooseFriend')}}</h4>
              <v-container wrap style="padding-top: 0px; height: calc(100vh - 100px); overflow-y: scroll;">
                <v-layout row wrap>
                  <v-flex sm12 xs12 class="borderlistfriend">
                    <v-text-field v-model="searchfriend" solo hide-details append-icon="search" :label="$t('LeftSide.createGroup.searching')" clearable />
                      <v-list class="CSChatThai widthfull scrolling-wrapper" style="padding: 0px; margin-top:10px;"  v-if="FilterFriendList.length != 0" >
                        <template v-for="(item, index) in FilterFriendList">
                          <v-list-tile :key="item.tokenuser" avatar ripple >
                            <v-list-tile-avatar>
                              <img  v-if="item.profilepicture"  :src="item.profilepicture" class="alligator-turtle">
                              <img v-else-if="item.type === 'company'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                              <img v-else-if="item.type === 'government'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                              <img v-else-if="item.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                              <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                              <v-list-tile-title class="textoverflow">
                                {{ item.name }}
                              </v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                              <v-checkbox v-model="selected" :value="item" style="color: #2562af !important;">
                              </v-checkbox>
                            </v-list-tile-action>
                          </v-list-tile>
                          <!-- <v-divider v-if="index + 1 < FriendList.length" :key="index"></v-divider> -->
                        </template>
                      </v-list>
                      <v-container v-else>
                        <v-list>
                          <v-list-tile @click="showDialog('AddFriend')">
                            <v-list-tile-content>
                              <v-list-tile-title class="CSChatThai " style="font-size:12px;text-align:center;color: black;">
                                <v-icon style="color: black;  font-size: 18px !important;">add_circle</v-icon>
                                {{$t('AnswerQuestion.addFriend')}}
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-list>
                      </v-container>
                  </v-flex>
                  <v-flex sm12 md12 lg12 xl12 class="borderlistfriendSelect">
                    <div class="setBorder ml-1">
                      <v-layout row wrap class="setPaddingButtomListFriendInGroup" style="margin-top: 5px;">
                        <h4 style="padding-left: 12px;" v-if="selected.length != 0">{{$t('RightSide.member')}} ({{selected.length}})</h4>
                      </v-layout>
                      <div class="scrolling-wrapperx" v-if="selected.length != 0">
                        <v-item-group>
                          <v-item
                            v-for="(i, index) in selected"
                            :key="index"
                          >
                            <v-chip slot-scope="{ active }" :selected="active" close @input="removeListAddGroup(i)">
                              <v-avatar>
                                <img v-if="i.profilepicture" :src="i.profilepicture" :alt="i.name" class="alligator-turtle">
                                <img v-else-if="i.type === 'company'" src='/static/img/default_profile/business-white.png' :alt="i.name">
                                <img v-else-if="i.type === 'government'" src='/static/img/default_profile/business-white.png' :alt="i.name">
                                <img v-else-if="i.type === 'bot'" src='/static/img/default_profile/bot-white.png' :alt="i.name">
                                <img v-else src='/static/img/default_profile/man-white.png' :alt="i.name">
                              </v-avatar>
                              {{i.name}}
                            </v-chip>
                          </v-item>
                        </v-item-group>
                      </div>
                      <div v-else style="margin-top: 40px;">
                        <v-layout align-center justify-center fill-height row>
                          <h5>{{$t('LeftSide.createGroup.noneSelect')}}</h5>
                        </v-layout>
                      </div>
                    </div>
                  </v-flex>
                </v-layout>
                <v-layout row warp class="mt-3">
                  <v-flex class="text-xs-left">
                    <v-btn @click="toPage()" class="CSChatThai btncanclegroup">{{$t('AnswerQuestion.cancel')}} </v-btn>
                  </v-flex>
                  <v-flex class="text-xs-right">
                    <v-btn color="primary" class="CSChatThai btncreategroup" :disabled="!(selected.length !== 0)" @click="step_creategroup = 2">{{$t('Task.allTask.next')}}</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-stepper-content>

            <v-stepper-content step="2">
              <h4 style="padding-left: 10px;">{{$t('AnswerQuestion.createGroup')}}</h4>
              <v-container wrap style="padding-top: 0px; height: calc(100vh - 100px); overflow-y: scroll;">
                <v-layout row wrap>
                  <v-flex sm12 xs12 md12 style="display: flex; justify-content: center;">
                    <div  class="List_item_body">
                      <div class="SettingImg">
                        <div class="SettingImgWrap">
                          <div>
                            <img src='/static/img/default_profile/group-white.png' class="alligator-turtle" style="cursor: pointer; width: 130px;height: 130px;"  v-if="imageData == ''" @click="uppic">
                            <img :src="imageData" class="alligator-turtle" @click="uppic" v-else style="cursor: pointer; width: 130px;height: 130px;" >
                            <div style="display: none;">
                              <input class="CSChatThai" type="file" name="file1" @change="previewImageweb" accept="image/*" id="uploadpicgroupweb" />
                            </div>
                            <label for="SettingImg" class="SettingImgBtn" @click="uppic()">
                              {{$t('AnswerQuestion.selectPicture')}}
                            </label>
                          </div>
                        </div>
                      </div>
                      <p class="EditAreaNote">{{$t('Settings.editProfile.support')}} .JPEG/.PNG/.GIF</p><p class="EditAreaNote"></p><p class="EditAreaNote"></p>
                    </div>
                  </v-flex>
                  <v-flex sm12 xs12 md12 class="mt-2">
                    <v-layout align-center justify-center row>
                      <input type="text" :placeholder="$t('LeftSide.createGroup.detailSearch')" class="CSChatThai inputgroupweb" v-model="GroupName">
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3">
                  <v-flex class="text-xs-left">
                    <template>
                      <v-btn @click="step_creategroup = 1" class="CSChatThai btncanclegroup">{{$t('Register.Button.back')}}</v-btn>
                    </template>
                  </v-flex>
                  <v-flex class="text-xs-right">
                    <v-btn class="CSChatThai btncreategroup" :loading="loading" :disabled="!(selected.length !== 0 && GroupName !== '')" @click="submit()">{{$t('AnswerQuestion.createGroup')}}</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
        <!-- <v-card-text style="height: calc(100vh - 124px); overflow-y: scroll;">
          <v-container wrap style="padding-top: 0px;">
            <v-layout wrap row>
              <v-flex xs6 sm6 md6 lg6 xl6>
                <v-layout align-center justify-center column fill-height>
                  <v-badge color="orange darken-1" overlap bottom>
                    <v-icon slot="badge" dark small style=" font-size: 8px !important; cursor: pointer;" @click="uppic">
                      add_a_photo
                    </v-icon>
                    <v-avatar style="" size="80px">
                      <img src='/static/img/default_profile/group-white.png' class="alligator-turtle" style="border: 2px #1a222c !important; border-style: dotted solid !important; cursor: pointer;" v-if="imageData == ''" @click="uppic">
                      <img :src="imageData" class="alligator-turtle" @click="uppic" v-else style="border: 2px #1a222c !important; border-style: dotted solid !important; cursor: pointer;">
                      <div style="display:none; color: black !important;">
                        <input class="CSChatThai" type="file" name="file1" @change="previewImageweb" accept="image/*" id="uploadpicgroupweb" />
                      </div>
                    </v-avatar>
                  </v-badge>
                </v-layout>
              </v-flex>
              <v-flex xs6 sm6 md6 lg6 xl6>
                <v-layout align-center justify-center column fill-height class="mt-2">
                  <v-text-field v-model="GroupName" solo :placeholder="$t('LeftSide.createGroup.detailSearch')"></v-text-field>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout column row>
              <v-flex xs12 sm12 md12 lg12 xl12 class="borderlistfriend">
                <v-text-field v-model="searchfriend" solo append-icon="search" :label="$t('LeftSide.createGroup.searching')" clearable></v-text-field>
                  <v-list two-line class="CSChatThai widthfull heightListSearch" style="padding: 0px;" v-if="FilterFriendList.length != 0" >
                    <template v-for="(item, index) in FilterFriendList">
                      <v-list-tile :key="item.tokenuser" avatar ripple >
                        <v-list-tile-action>
                          <v-checkbox v-model="selected" :value="item">
                          </v-checkbox>
                        </v-list-tile-action>
                        <v-list-tile-avatar>
                          <img  v-if="item.profilepicture"  :src="item.profilepicture" class="alligator-turtle">
                          <img v-else-if="item.type === 'company'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                          <img v-else-if="item.type === 'government'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                          <img v-else-if="item.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                          <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title class="textoverflow">
                            {{ item.name }}
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider v-if="index + 1 < FriendList.length" :key="index"></v-divider>
                    </template>
                  </v-list>
                  <v-list v-else>
                    <v-list-tile @click="toPage_Addfriend('/mobile/addfriend')">
                      <v-list-tile-content>
                        <v-list-tile-title class="CSChatThai " style="font-size:12px;text-align:center;color: black;">
                          <v-icon style="color: black;  font-size: 18px !important;">add_circle</v-icon>
                          {{$t('AnswerQuestion.addFriend')}}
                        </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-flex>
              </v-layout>
          </v-container>
          <v-layout align-center justify-center row>
            <v-btn class="CSChatThai btncreategroup text-transform" :loading="loading" :disabled="selected.length == 0 || GroupName == ''" @click="submit()">{{$t('AnswerQuestion.createGroup')}}
          </v-btn>
            <v-btn @click.native="closeDialog" class="btncanclegroup text-transform">{{$t('AnswerQuestion.cancel')}}</v-btn>
          </v-layout>
        </v-card-text> -->
      <!-- </v-card> -->
      <!-- <AddDialog :dialogAdd="AddFriend" v-on:closeDialogAddFriend="closeDialogAddFriend"></AddDialog> -->
    <!-- </v-dialog> -->
</div>
</vue100vh>
</template>

<script>
// import AddDialog from '@/components/chat/dialog/manage_friend/ManageFriendDialog'
import { sync } from 'vuex-pathify'
import { Decode } from '@/services'
import vue100vh from 'vue-100vh'
export default {
  data: () => ({
    loading: false,
    AddFriend: false,
    imageData: '',
    selectFile: '',
    token: '',
    selected: [],
    invites: [],
    idbusiness: [],
    GroupName: '',
    FriendList: [],
    searchfriend: '',
    business_id: '',
    listmember: [],
    typeuser: '',
    step_creategroup: 1
    // group_id: '',
    // group_createdate: '',
    // group_status: ''
  }),
  computed: {
    FilterFriendList () {
      if (this.searchfriend !== '' && this.searchfriend !== null) {
        return this.FriendList.filter(post => {
          return post.name.toLowerCase().includes(this.searchfriend.toLowerCase())
        })
      } else {
        return this.FriendList
      }
    },
    ...sync('*')
  },
  watch: {
    socketaccept_friend (data) {
      if (data.tokenuser === this.token) {
        this.axios.post(process.env.APImanage + '/getuser', {owner: this.token, tokenuser: [data.tokenfriend]}).then((response) => {
          var _ = require('lodash')
          // update list friend after accept friend
          if (_.find(this.FriendList, function (o) { return o.tokenuser === response.data.user[0].tokenuser }) === undefined) {
            this.FriendList.unshift({
              email: response.data.user[0].email,
              name: response.data.user[0].name,
              phone: response.data.user[0].phone,
              profilepicture: response.data.user[0].profilepicture,
              state: response.data.user[0].state,
              status: response.data.user[0].status,
              tokenuser: response.data.user[0].tokenuser,
              type: response.data.user[0].type,
              tokenroom: data.tokenroom
            })
            this.FriendList = _.orderBy(this.FriendList, ['name'], ['asc'])
          }
        })
      }
    }
  },
  components: {
    // AddDialog
    vue100vh
  },
  methods: {
    toPage_Addfriend (path) {
      this.$router.push(path)
    },
    toPage () {
      this.$router.go(-1)
    },
    removeListAddGroup (item) {
      this.selected.splice(this.selected.indexOf(item), 1)
    },
    showDialog (dialog) {
      if (dialog === 'AddFriend') {
        this.AddFriend = true
      }
    },
    closeDialogAddFriend (value) {
      this.AddFriend = value
    },
    uppic () {
      $('#uploadpicgroupweb').click()
    },
    closeDialog () {
      let self = this
      // this.$emit('closeDialogCreateGroup', false)
      this.invites = []
      this.idbusiness = []
      this.GroupName = ''
      this.selected = []
      self.imageData = ''
      self.selectFile = ''
      document.getElementById('uploadpicgroupweb').value = ''
      this.loading = false
    },
    previewImageweb (data) {
      var input = data.target
      this.selectFile = data.target.files[0]
      if (input.files && input.files[0]) {
        var reader = new FileReader()
        reader.onload = (e) => {
          this.imageData = e.target.result
        }
        reader.readAsDataURL(input.files[0])
      }
    },
    submit () {
      if (this.selected.length < 1) {
        this.$swal({
          title: this.$t('Alert.Fail.createGroup.title'),
          text: this.$t('Alert.Fail.createGroup.selectFriend'),
          type: 'warning',
          showCloseButton: true,
          reverseButtons: true
        })
      } else if (this.GroupName === '') {
        this.$swal({
          title: this.$t('Alert.Fail.createGroup.title'),
          text: this.$t('Alert.Fail.createGroup.groupname'),
          type: 'warning',
          showCloseButton: true,
          reverseButtons: true
        })
      } else {
        for (var i = 0; i < this.selected.length; i++) {
          this.invites[i] = this.selected[i].tokenuser
          // this.idbusiness[i] = this.selected[i].business_id
          // this.listmember[i] = {tokenuser: this.invites[i], business_id: this.idbusiness[i]}
          if (i === this.selected.length - 1) {
            this.loading = true
            // console.log(this.invites)
            this.axios.post(process.env.APInew_creategroup, {tokenuser: this.token, listmember: this.invites, group_name: this.GroupName}).then((response) => {
              if (response.data.status === 'success') {
                // console.log(response.data)
                if (this.selectFile !== '') {
                  var uploadFile = new FormData()
                  uploadFile.append('file', this.selectFile, this.selectFile.name)
                  uploadFile.append('group_id', response.data.group.group_id)
                  uploadFile.append('tokenuser', this.token)
                  this.axios.post(process.env.APImanage + '/setimagegroup', uploadFile).then((responsed) => {
                    // console.log(responsed.data)
                    if (responsed.data.status === 'success') {
                      this.$swal(
                        this.$t('Alert.Success.createGroup'),
                        '',
                        'success')
                      // let self = this
                      this.selectFile = ''
                      this.imageData = ''
                      this.selected = []
                      this.closeDialog()
                      document.getElementById('uploadpicgroupweb').value = ''
                      this.$emit('updatecreategroup', response.data.group, responsed.data.filename)
                      this.$emit('updatelistchat', response.data.group, responsed.data.filename)
                      this.loading = false
                    }
                    this.$router.push('/mobile/homepage')
                    // this.$emit('closeDialogCreateGroup', false)
                  })
                } else {
                  // let self = this
                  this.$swal(
                    this.$t('Alert.Success.createGroup'),
                    '',
                    'success')
                  this.selectFile = ''
                  this.imageData = ''
                  this.selected = []
                  this.closeDialog()
                  document.getElementById('uploadpicgroupweb').value = ''
                  // this.$emit('closeDialogCreateGroup', false)
                  this.$emit('updatecreategroup', response.data.group)
                  this.$emit('updatelistchat', response.data.group)
                  // console.log(this.$emit('updatecreategroup', response.data.group))
                  this.$router.push('/mobile/homepage')
                  this.loading = false
                }
              } else {
                // console.log(response.data)
                this.loading = false
              }
            })
          }
        }
      }
    }
  },
  created () {
    var decoded = JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
    this.business_id = localStorage.getItem('business_id')
    this.typeuser = localStorage.getItem('type_user')
    this.axios.post(process.env.APImanage + '/web/getlistfriend', {tokenuser: this.token}).then((response) => {
      // console.log(response.data)
      this.FriendList = response.data['listfriend']
    })
    this.$i18n.locale = (this.$cookie.get('language'))? this.$cookie.get('language'): 'th'
  }
}
</script>
<style scoped>
.text-transform {
  text-transform: none !important;
}
>>>.v-badge--overlap .v-badge__badge {
  top: 59px !important;
  right: 7px !important;
}
>>>.v-badge--overlap.v-badge--bottom .v-badge__badge {
  bottom: 20px;
  top: 70px;
}
>>>.v-toolbar {
  /* box-shadow: none; */
  box-shadow: 0 2px 0px -1px hsla(0,0%,100%,.12), 0 0px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12);
}
.btncreategroup {
  border-radius: 7px !important;
  color: white !important;
  background-color: #2562af !important;
}
.btncanclegroup {
  border-radius: 7px !important;
  color: #1b232db3 !important;
  background-color: #cacacae3 !important;
}
>>> .v-messages {
  min-width: 1px;
  position: relative;
}
>>> .v-list__tile__action, .v-list__tile__avatar {
  display: flex;
  justify-content: flex-start;
  min-width: 40px;
}
.textoverflow {
  padding-left: 12px;
  white-space: nowrap;
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.widthfull{
  width: 100%;
}
.heightfull {
  min-height: 100vh !important;
}
.heightListSearch {
  /*min-height: 170px !important;*/
  height: 170px !important;
  width: 99%;
  overflow-y: scroll;
}
.borderlistfriend {
  /* border-radius: 4px; */
  margin-top: 15px;
  /* border-color: #cccccc; */
  /* border-style: solid; */
  border-width: thin;
  height: 250px;
}
.borderlistfriendSelect {
  border-radius: 4px;
  margin-top: 10px;
  border-color: #b7b7b7;
  border-style: solid;
  border-width: thin;
  height: 100px;
}
.Kanit{
  font-family: 'Kanit', sans-serif !important;
}
.fileInput {
  color: white;
  width: 21vw !important;
}
.inputWrapper {
    height: 32px;
    width: 70px;
    overflow: hidden;
    position: relative;
    cursor: pointer;
    margin-top: 5vh;
    /*Using a background color, but you can use a background image to represent a button*/
    /*background-color: #DDF;*/
}

.cardlist{
    padding-top: 10px;
    width: 100%;
    height: 30vh;
    overflow-x: hidden;
    overflow-y: scroll;
}

.cardlist::-webkit-scrollbar{
    width: 10px;
}

.cardlist::-webkit-scrollbar-thumb{
    border-radius: 5px;
    background: rgba(0, 0, 0, .1);
}
.alligator-turtle {

  object-fit: cover;
  object-position: 50% 0;
}
>>>.inputgroupweb {
  color: black !important;
  font-size: 16px !important;
}
input[type=text] {
  width: 100%;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 7px;
  font-size: 16px;
  background-color: white;
  background-image: url('/static/img/default_profile/group-white.png');
  background-position: 10px 10px;
  background-repeat: no-repeat;
  padding: 12px 20px 12px 20px;
  -webkit-transition: width 0.4s ease-in-out;
  transition: width 0.4s ease-in-out;
}
>>> .v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0px !important;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
  /*box-shadow: none;*/
  border-width: thin !important;
  border-style: solid !important;
  border-radius: 20px !important;
  border-color: #808080a6 !important;
  box-shadow: none !important;
}
.scrolling-wrapper {
  /*display: flex;*/
  height: 160px !important;
  overflow-y: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 8px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}
.scrolling-wrapperx {
  /*display: flex;*/
  width: 95%;
  overflow-x: auto;
}
.scrolling-wrapperx::-webkit-scrollbar {
  height: 4px;
  width: 8px;
}
.scrolling-wrapperx::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}
>>> .v-item-group {
  width: max-content;
}
.EditAreaNote {
  margin: 8px 0 0;
  font-size: 13px;
  color: #BEC8D2;
  font-size: 12px;
}
.SettingImgWrap {
  display: inline-block;
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  margin-top: 20px;
}
.SettingImgBtn {
    display: block;
    overflow: hidden;
    position: absolute;
    bottom: -20px;
    right: -20px;
    line-height: 1;
    width: 40px;
    height: 30px;
    bottom: 0;
    left: 0;
    line-height: 30px;
    width: 100%;
    text-align: center;
    cursor: pointer;
    color: #fff;
    background: rgba(0, 0, 0, .5);
}

.SettingImgBtn:hover {
  display: block;
  overflow: hidden;
  position: absolute;
  bottom: -20px;
  right: -20px;
  line-height: 1;
  width: 40px;
  height: 50%;
  bottom: 0;
  left: 0;
  line-height: 30px;
  width: 100%;
  text-align: center;
  cursor: pointer;
  color: #fff;
  background: rgba(0, 0, 0, .75);
}
/*>>>.v-input .v-text-field .v-text-field--single-line .v-text-field--solo .v-text-field--enclosed .theme--light {
  margin: 10px !important;
}*/
</style>



// WEBPACK FOOTER //
// src/components/mobile/manage/Creategroup.vue